// Module
var code = "<div class=\"articles\">\n  <customer\n    customer-id=\"vm.customer.id\"\n    concept-id=\"vm.concept.id\"\n    concept-customer-id=\"vm.concept.customerId\"\n  ></customer>\n</div>\n";
// Exports
module.exports = code;